import { useContext } from 'react';
import AnimatingContext from '../../../contexts/AnimatingContext';

export default function useIsAnimating() {
    const { isAnimating } = useContext(AnimatingContext);
    return isAnimating;
}
